var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareModalCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2360",
    "data-name": "Rectangle 2360",
    width: 30,
    height: 30,
    transform: "translate(-0.275 -0.275)",
    fill: "#f53546"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "closeIcon",
    transform: "translate(-1190 -135)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2229",
    "data-name": "Ellipse 2229",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1190 135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7812",
    "data-name": "Group 7812",
    transform: "translate(1192.275 137.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7811",
    "data-name": "Group 7811",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19951",
    "data-name": "Path 19951",
    d: "M27.331,12.813v1.6c-.022.193-.045.385-.066.578a13.48,13.48,0,0,1-2.19,6.141,13.471,13.471,0,0,1-9.029,5.989c-.5.094-1.018.143-1.527.213h-1.6c-.086-.016-.172-.036-.259-.049-.6-.088-1.2-.136-1.79-.267a13.558,13.558,0,0,1-8.41-5.641A13.221,13.221,0,0,1,.07,12.267,13,13,0,0,1,3.126,5.005,13.512,13.512,0,0,1,13.134.018a12.925,12.925,0,0,1,7.538,1.906,13.416,13.416,0,0,1,6.446,9.336c.1.513.143,1.035.213,1.553m-11.421.8a3.415,3.415,0,0,0,.3-.23q2.05-2.045,4.095-4.095a3.438,3.438,0,0,0,.3-.338A1.6,1.6,0,0,0,18.1,6.966q-2.087,2.083-4.169,4.171c-.067.067-.138.13-.213.2-.074-.069-.133-.121-.19-.176q-2.119-2.07-4.238-4.14a3.607,3.607,0,0,0-.34-.3A1.6,1.6,0,0,0,6.966,9.232q2.081,2.089,4.168,4.172c.067.067.13.138.234.249a2.5,2.5,0,0,0-.25.192q-2.049,2.045-4.094,4.1a3.413,3.413,0,0,0-.3.338,1.592,1.592,0,0,0,.492,2.329,1.61,1.61,0,0,0,2-.325q2.15-2.1,4.295-4.2c.068-.066.138-.13.245-.231a2.8,2.8,0,0,0,.2.252q2.045,2.05,4.093,4.1a3.421,3.421,0,0,0,.338.3A1.6,1.6,0,0,0,20.363,18q-2.072-2.079-4.152-4.15a3.538,3.538,0,0,0-.3-.232",
    transform: "translate(1.107 1.199)",
    fill: "#f53546"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareModalCloseIcon);
export default __webpack_public_path__ + "static/media/share-modal-close-icon.347249ce2538747ad772068653a2b346.svg";
export { ForwardRef as ReactComponent };